import * as Models from "../.";

export interface IAmendNameAddressRequest {
    contractAmendmentDetails: IContractAmendmentDetails;
    igsCustomerNumber: string;
  }
  
  export class AmendNameAddressRequest implements IAmendNameAddressRequest {
    contractAmendmentDetails: IContractAmendmentDetails;
    igsCustomerNumber: string;
  }


  export interface IName {
    firstName: string;
    middleName: string;
    lastName: string;
  }

  export class Name implements IName {
    firstName: string;
    middleName: string
    lastName: string;

    
    static createNewName = (name: Name): Name =>  {
      var newName = new Name();

      newName.firstName = name.firstName;
      newName.middleName = name.middleName;
      newName.lastName = name.lastName;
      
      return newName;
    }

  }
  

  export interface IContractAmendmentDetails {
    amendName: boolean;
    amendAddress: boolean;
    amendTrust: boolean;
    address: Models.Customer.Address.Address;
    name: Name;
    trustName: string;
    isInTrust: boolean;
  }

  export class ContractAmendmentDetails implements IContractAmendmentDetails {
    amendName: boolean;
    amendAddress: boolean;
    amendTrust: boolean;
    address: Models.Customer.Address.Address;
    name: Name;
    trustName: string;
    isInTrust: boolean;
  }